import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "9e27f7a679e29e1a43c518744338bab3.jpg",
    width: 1125,
    height: 2190
});